import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ResizeGlyphComponent } from 'app/resize-glyph/resize-glyph.component';

@NgModule({
    imports: [CommonModule],
    declarations: [ResizeGlyphComponent],
    exports: [ResizeGlyphComponent]
})
export class ResizeGlyphModule {

}


// WEBPACK FOOTER //
// ./src/app/resize-glyph/resize-glyph.module.ts